import { useState } from 'react'

const useUnblockPopupDetail = () => {
    const [openIosHelp, setOpenIosHelp] = useState(false)

    const handleClickOpenIosHelp = () => {
        setOpenIosHelp(true)
    }

    const handleClickCloseIosHelp = () => {
        setOpenIosHelp(false)
    }

    return {
        openIosHelp,
        onClickOpenIosHelp: handleClickOpenIosHelp,
        onClickCloseIosHelp: handleClickCloseIosHelp,
    }
}

export default useUnblockPopupDetail
